<template>
  <div class="login">
    <div class="top-block">
      <!-- <div class="tip-text">
        <img src="../../assets/images/file_logo.png" />
      </div> -->
      <p class="tip-text logo-meta">欢迎使用{{oem.name || ''}}商家版连锁店后台</p>
    </div>
    <div class="float-block">
      <form id="session-form">
        <div class="form-input-wrap"
             data-controller="sessions--new">
          <div class="input-group">
            <input type="tel"
                   class="form-control phone-input chengbao-keyboard"
                   placeholder="请输入手机号"
                   v-model="phone" />
            <span class="input-group-btn">
              <button class="btn btn-default"
                      type="button"
                      @click="sendCode">
                <span v-if="isSendCode"
                      style="color: #d6d6d6;">{{ countdown }}S</span>
                <span v-if="!isSendCode">发送验证码</span>
              </button>
            </span>
          </div>
          <div class="input-group">
            <input type="text"
                   class="form-control captcha-input chengbao-keyboard"
                   placeholder="请输入验证码"
                   autocomplete="off"
                   v-model="code" />
          </div>
          <div class="submit-row"
               :class="isDisabled ? 'disabled' : ''">
            <div class="form-submit"
                 @click="submit">登录</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval } from 'timers'
import axios from 'axios'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      phone: '',
      code: '',
      isAgreeProtocol: true,
      isSendCode: false,
      countdown: 60,
      timer: '',
      isDisabled: true
    }
  },
  components: {},
  watch: {
    code (val) {
      this.btnIsDisabled(val)
    },
    phone (val) {
      this.btnIsDisabled(val)
    }
  },
  computed: {
    ...mapGetters('editor', ['me']),
    ...mapState('oem', ['oem'])
  },
  methods: {
    ...mapActions('editor', ['login']),
    handleSubmit ({ telephone, password }) {
      this.login({ telephone, password })
    },
    async sendCode () {
      if (this.phone === '') {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return -1
      }
      if (!/^(1)\d{10}$/.test(this.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
        return -1
      }

      await axios.post('/sessions/sms', {
        mobile: this.phone
      })
      this.isSendCode = true
      this.countdownFun()
    },
    countdownFun () {
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown === 0) {
          clearInterval(this.timer)
          this.countdown = 60
          this.isSendCode = false
        }
      }, 1000)
    },
    btnIsDisabled (val) {
      if (val && /^(1)\d{10}$/.test(this.phone)) {
        this.isDisabled = false
      } else {
        this.isDisabled = true
      }
    },
    async submit () {
      this.login({ mobile: this.phone, code: this.code })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  .top-block {
    height: 20vw;
    background: url("../../assets/images/merchant_sign_in.png") no-repeat;
    background-size: cover;

    .tip-text {
      img {
        margin-top: 1.8666666667vw;
        position: absolute;
        width: auto;
        left: 1.8666666667vw;
        height: 2.6666666667vw;
      }
    }

    .logo-meta {
      padding-top: 4.5333333333vw;
      margin-top: 0;
      font-size: 2.8vw;
      color: #fff;
      font-weight: 400;
      text-align: center;
    }
  }

  .float-block {
    top: -9.3333333333vw;
    margin: 0 auto;
    position: relative;
    width: 49.3333333333vw;
    z-index: 10;

    .form-input-wrap {
      border-radius: 5px;
      background-color: #fff;
      padding-top: 10px;
      height: 30.2vw;
      border: none;
      -webkit-box-shadow: 0px 0px 0.8vw 0px rgba(0, 0, 0, 0.3);
      -moz-box-shadow: 0px 0px 0.8vw 0px rgba(0, 0, 0, 0.3);
      box-shadow: 0px 0px 0.8vw 0px rgba(0, 0, 0, 0.3);

      .submit-row {
        width: 44vw;
        margin: 2.4vw auto 0 auto;
        padding: 0;
        -webkit-border-radius: 50px;
        -moz-border-radius: 50px;
        border-radius: 50px;
        border: solid 1px #d43c33;

        .form-submit {
          background-color: #fff;
          color: #d43c33;
          display: block;
          // width: 44vw;
          font-size: 1.8666666667vw;
          line-height: 4vw;
          text-align: center;
          // padding    : 0 21.3333333333vw;
          text-align: center;
          border: none;
          outline: none;
          -webkit-border-radius: 50px;
          -moz-border-radius: 50px;
          border-radius: 50px;
        }
      }

      .disabled {
        border: none;

        .form-submit {
          background-color: #eaeaea;
          color: #898989;
          display: block;
          width: 44vw;
          font-size: 1.8666666667vw;
          line-height: 4vw;
          text-align: center;
          // padding    : 0 21.3333333333vw;
        }
      }

      .input-group {
        margin: 2.4vw auto 0 auto;
        width: 45.3333333333vw;
        height: 4.2666666667vw;
        border: 1px solid #aaaaaa;
        border-radius: 5px;

        input {
          border: none;
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
          outline: none;
          background-color: transparent;
          -webkit-tap-highlight-color: transparent;
          font-size: 18px;
          vertical-align: text-top;
          width: 26.6666666667vw;
          font-size: 18px;
          padding-left: 1.3333333333vw;
          line-height: 4.2666666667vw;

          &::-webkit-input-placeholder {
            color: #c1c1c1;
          }
        }

        .btn-default {
          font-size: 1.3333333333vw;
          height: 100%;
          color: #d43c33;
          float: right;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: none;
          background-color: inherit;
          outline: none;
        }

        .input-group-btn {
          position: relative;
          line-height: inherit;
          right: 0.6666666667rem;
        }
      }
    }

    .tip {
      font-size: 1.3333333333vw;
      margin-top: 1.3333333333vw;
      text-align: center;

      a {
        color: #4a90e2;
        text-decoration: none;
      }
    }
  }
}
</style>
